<template>
  <el-form :model="group" label-width="80px" :loading="loading">
    <el-form-item label="名称" required>
      <el-input placeholder="权限分组的名称" v-model="group.name"/>
    </el-form-item>
    <el-form-item label="备注">
      <el-input type="textarea" v-model="group.remark" multiline/>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submitSaveAction">确 定</el-button>
      <el-button @click="close">取 消</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import {addGroup, updateGroup} from './employeeApi'

export default {
  name: 'addPermissionGroup',
  data () {
    return {
      loading: false,
      group: {
        name: '',
        remark: ''
      },
      addOrEdit: true
    }
  },
  props: {
    data: {
      name: '',
      remark: '',
      groupId: ''
    }
  },
  created () {
    if (this.data !== undefined && this.data !== null) {
      const copy = JSON.parse(JSON.stringify(this.data))
      const { groupId } = copy
      this.addOrEdit = groupId === undefined
      this.group = copy
    }
  },
  watch: {
    data (d) {
      const copy = JSON.parse(JSON.stringify(d))
      const { groupId } = copy
      this.addOrEdit = groupId === undefined
      this.group = copy
    }
  },
  methods: {
    submitSaveAction () {
      if (this.addOrEdit === true) {
        this.submitAddAction()
      } else {
        this.submitUpdateSku()
      }
    },
    submitAddAction () {
      const name = this.group.name.trim()
      if (name.length === 0) {
        this.$message.error('名称不能为空')
        return
      }
      this.loading = true
      addGroup(this.group).then(rsp => {
        this.loading = false
        const {code, message} = rsp
        if (code === 0) {
          this.$message.success('添加成功')
          this.$emit('success')
        } else {
          this.$message.error(message)
        }
      }).catch(() => {
        this.loading = false
      })
    },
    submitUpdateSku () {
      this.loading = true
      updateGroup(this.group).catch(() => {
        this.loading = false
      }).then((rsp) => {
        const {code, message} = rsp
        if (code === 0) {
          this.$message.success('修改成功')
          this.$emit('success')
        } else {
          this.$message.error(message)
        }
      })
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/employee/addPermissionGroup.vue